module.exports = __webpack_public_path__ + "static/media/sj-forester.b969fc68.webp";